export default __webpack_public_path__ + "static/media/recommended.94f730d8.png";